// src/redux/settingsPages/legalConsent/legalConsentAPI.js
import apiClient from '../../authentication/utils/core/axios';

const LegalConsentAPI = {
  async getConsent() {
    const res = await apiClient.get('/legal/consent');
    return res.data; // LegalConsentResponse
  },

  async patchConsent(patch) {
    const res = await apiClient.patch('/legal/consent', patch);
    return res.data;
  },
};

export default LegalConsentAPI;
